<template>
  <div>
<!--     <div>
      <h1 class="mb-3">Explore the data</h1>
    </div> -->
    <v-card>
      <v-container class="mx-3">
        <v-container fluid>
          <h2>1. Object Classes</h2>
          <p>Here are the parent and child denominations for all 60 object classes in xView. Parent classes are at the headings of each column. The only exception is the last column 'None', which corresponds to classes that have no parent.</p>
        </v-container>

        <v-container fluid>
          <!-- New row on wide viewports, all single column on small-->
          <v-layout row justify-center class="mx-2 mb-4" v-bind="vpLayout">
          <!-- <v-layout row justify-center class="mx-2 mb-4" v-bind="vpLayout"> -->

            <!-- A table for a few object classes -->
            <v-flex xs2 sm3 class="mx-2 my-2">
              <v-data-table
                :headers="headersObjectClass1"
                :items="itemsObjectClass1"
                hide-actions
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <!-- <td>{{ props.item.name }}</td> -->
                  <td class="text-xs-left">{{ props.item.class_name}}</td>
                </template>
              </v-data-table>
            </v-flex>

            <v-flex xs2 sm3 class="mx-2 my-2">
              <v-data-table
                :headers="headersObjectClass2"
                :items="itemsObjectClass2"
                hide-actions
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <!-- <td>{{ props.item.name }}</td> -->
                  <td class="text-xs-left">{{ props.item.class_name}}</td>
                </template>
              </v-data-table>
            </v-flex>

          </v-layout>  <!-- end row/group -->

          <!-- New row/group -->
          <v-layout row justify-center class="mx-2 mb-4" v-bind="vpLayout">

            <v-flex xs2 sm3 class="mx-2 my-2">
              <v-data-table
                :headers="headersObjectClass7"
                :items="itemsObjectClass7"
                hide-actions
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <!-- <td>{{ props.item.name }}</td> -->
                  <td class="text-xs-left">{{ props.item.class_name}}</td>
                </template>
              </v-data-table>
            </v-flex>

            <v-flex xs2 sm3 class="mx-2 my-2">
              <v-data-table
                :headers="headersObjectClass3"
                :items="itemsObjectClass3"
                hide-actions
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <!-- <td>{{ props.item.name }}</td> -->
                  <td class="text-xs-left">{{ props.item.class_name}}</td>
                </template>
              </v-data-table>
            </v-flex>

          <!-- Another table for a few other object classes -->
            <v-flex xs2 sm3 class="mx-2 my-2">
              <v-data-table
                :headers="headersObjectClass4"
                :items="itemsObjectClass4"
                hide-actions
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <!-- <td>{{ props.item.name }}</td> -->
                  <td class="text-xs-left">{{ props.item.class_name}}</td>
                </template>
              </v-data-table>
            </v-flex>

          </v-layout>  <!-- end row -->

          <!-- Another table for a few other object classes -->
          <v-layout row justify-center class="mx-2" v-bind="vpLayout">

            <v-flex xs2 sm3 class="mx-2 my-2">
              <v-data-table
                :headers="headersObjectClass5"
                :items="itemsObjectClass5"
                hide-actions
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <!-- <td>{{ props.item.name }}</td> -->
                  <td class="text-xs-left">{{ props.item.class_name}}</td>
                </template>
              </v-data-table>
            </v-flex>

          <!-- Another table for a few other object classes -->
            <v-flex xs2 sm3 class="mx-2 my-2">
              <v-data-table
                :headers="headersObjectClass6"
                :items="itemsObjectClass6"
                hide-actions
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <!-- <td>{{ props.item.name }}</td> -->
                  <td class="text-xs-left">{{ props.item.class_name}}</td>
                </template>
              </v-data-table>
            </v-flex>

          <!-- Another table for a few other object classes -->
            <v-flex xs2 sm3 class="mx-2 my-2">
              <v-data-table
                :headers="headersObjectClass8"
                :items="itemsObjectClass8"
                hide-actions
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <!-- <td>{{ props.item.name }}</td> -->
                  <td class="text-xs-left">{{ props.item.class_name}}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>

        </v-container> <!-- end row --> 

        <!-- <v-divider class="my-3"></v-divider> -->
        <v-container fluid>
          <v-layout row justify-center class="my-3">
            <v-flex fluid>
              <h2 class="mt-3 mb-1">2. Examples</h2>
              <p class="my-3">Example input, just image/pixel data:</p>
              <img :src="path_to_unlabeled_image" width="600px"><br>
              <p class="my-3">Example output, with bounding boxes rendered visually:</p>
              <img :src="path_to_labeled_image" width="600px"><br>
            </v-flex>
          </v-layout>
        </v-container>


        <v-container fluid>
          <h2 class="mt-3 mb-1">3. Publication</h2>
          <h3  class="mt-3 mb-1">Abstract</h3>
          <p>xView is a new large-scale dataset for the advancement of object detection techniques and overhead object detection research. This satellite imagery dataset enables research progress pertaining to four key computer vision frontiers. We utilize a novel process for geospatial category detection and bounding box annotation with three stages of quality control. Our data is collected from WorldView-3 satellites at 0.3m ground sample distance, providing higher resolution imagery than most public satellite imagery datasets. We compare xView to other object detection datasets in both natural and overhead imagery domains and then provide a baseline analysis using the Single Shot MultiBox Detector. xView is one of the largest and most diverse publicly available object detection datasets to date, with over 1 million objects across 60 classes in over 1,400 km<sup>2</sup> of imagery.</p>
          <p>The xVIEW dataset has been fully described in a paper which is freely available via arXiv.org: We encourage you to download and read the paper for more details.</p>
          <p><a href="https://arxiv.org/abs/1802.07856" target="_blank">Link to paper (arxiv.org)</a> </p>
        </v-container>

      </v-container>
    </v-card>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        path_to_unlabeled_image: 'static/example_unlabeled.jpg', // full: 600x600px
        path_to_labeled_image: 'static/example_labeled.jpg',

        headersObjectClass1: [
          {'text': 'Fixed-Wing Aircraft', 'align': 'left', 'sortable': false, 'value': 'class_name', 'class': 'cardgray'}
        ],
        itemsObjectClass1: [
          {'value': false, 'align': 'left', 'class_name': 'Small Aircraft'},
          {'value': false, 'align': 'left', 'class_name': 'Cargo Plane'}
        ],

        headersObjectClass2: [
          {'text': 'Passenger Vehicle', 'align': 'left', 'sortable': false, 'value': 'class_name', 'class': 'cardgray'}
        ],
        itemsObjectClass2: [
          {'value': false, 'align': 'left', 'class_name': 'Small Car'},
          {'value': false, 'align': 'left', 'class_name': 'Bus'}
        ],

        headersObjectClass3: [
          {'text': 'Truck', 'align': 'left', 'sortable': false, 'value': 'class_name', 'class': 'cardgray'}
        ],
        itemsObjectClass3: [
          {'value': false, 'align': 'left', 'class_name': 'Pickup Truck'},
          {'value': false, 'align': 'left', 'class_name': 'Utility Truck'},
          {'value': false, 'align': 'left', 'class_name': 'Cargo Truck'},
          {'value': false, 'align': 'left', 'class_name': 'Truck w/Box'},
          {'value': false, 'align': 'left', 'class_name': 'Truck Tractor Trailer'},
          {'value': false, 'align': 'left', 'class_name': 'Truck w/Flatbed'},
          {'value': false, 'align': 'left', 'class_name': 'Truck w/Liquid'}
        ],

        headersObjectClass4: [
          {'text': 'Railway Vehicle', 'align': 'left', 'sortable': false, 'value': 'class_name', 'class': 'cardgray'}
        ],
        itemsObjectClass4: [
          {'value': false, 'align': 'left', 'class_name': 'Passenger Car'},
          {'value': false, 'align': 'left', 'class_name': 'Cargo Car'},
          {'value': false, 'align': 'left', 'class_name': 'Flat Car'},
          {'value': false, 'align': 'left', 'class_name': 'Tank Car'},
          {'value': false, 'align': 'left', 'class_name': 'Locomotive'}
        ],

        headersObjectClass5: [
          {'text': 'Maritime Vessel', 'align': 'left', 'sortable': false, 'value': 'class_name', 'class': 'cardgray'}
        ],
        itemsObjectClass5: [
          {'value': false, 'align': 'left', 'class_name': 'Motoboat'},
          {'value': false, 'align': 'left', 'class_name': 'Sailboat'},
          {'value': false, 'align': 'left', 'class_name': 'Tugboat'},
          {'value': false, 'align': 'left', 'class_name': 'Barge'},
          {'value': false, 'align': 'left', 'class_name': 'Fishing Vessel'},
          {'value': false, 'align': 'left', 'class_name': 'Ferry'},
          {'value': false, 'align': 'left', 'class_name': 'Yacht'},
          {'value': false, 'align': 'left', 'class_name': 'Container Ship'},
          {'value': false, 'align': 'left', 'class_name': 'Oil Tanker'}
        ],

        headersObjectClass6: [
          {'text': 'Engineering Vessel', 'align': 'left', 'sortable': false, 'value': 'class_name', 'class': 'cardgray'}
        ],
        itemsObjectClass6: [
          {'value': false, 'align': 'left', 'class_name': 'Tower Crane'},
          {'value': false, 'align': 'left', 'class_name': 'Container Crane'},
          {'value': false, 'align': 'left', 'class_name': 'Reach Stacker'},
          {'value': false, 'align': 'left', 'class_name': 'Straddle Carrier'},
          {'value': false, 'align': 'left', 'class_name': 'Mobile Crane'},
          {'value': false, 'align': 'left', 'class_name': 'Dump Truck'},
          {'value': false, 'align': 'left', 'class_name': 'Haul Truck'},
          {'value': false, 'align': 'left', 'class_name': 'Scraper/Tractor'},
          {'value': false, 'align': 'left', 'class_name': 'Front Loader'},
          {'value': false, 'align': 'left', 'class_name': 'Excavator'},
          {'value': false, 'align': 'left', 'class_name': 'Cement Mixer'},
          {'value': false, 'align': 'left', 'class_name': 'Ground Grader'},
          {'value': false, 'align': 'left', 'class_name': 'Crane Truck'}
        ],

        headersObjectClass7: [
          {'text': 'Building', 'align': 'left', 'sortable': false, 'value': 'class_name', 'class': 'cardgray'}
        ],
        itemsObjectClass7: [
          {'value': false, 'align': 'left', 'class_name': 'Hut/Tent'},
          {'value': false, 'align': 'left', 'class_name': 'Shed'},
          {'value': false, 'align': 'left', 'class_name': 'Aircraft Hangar'},
          {'value': false, 'align': 'left', 'class_name': 'Damaged Building'},
          {'value': false, 'align': 'left', 'class_name': 'Facility'}
        ],

        headersObjectClass8: [
          {'text': 'None', 'align': 'left', 'sortable': false, 'value': 'class_name', 'class': 'cardgray'}
        ],

        itemsObjectClass8: [
          {'value': false, 'align': 'left', 'class_name': 'Helipad'},
          {'value': false, 'align': 'left', 'class_name': 'Pylon'},
          {'value': false, 'align': 'left', 'class_name': 'Shipping Container'},
          {'value': false, 'align': 'left', 'class_name': 'Shipping Container Lot'},
          {'value': false, 'align': 'left', 'class_name': 'Storage Tank'},
          {'value': false, 'align': 'left', 'class_name': 'Vehicle Lot'},
          {'value': false, 'align': 'left', 'class_name': 'Construction Site'},
          {'value': false, 'align': 'left', 'class_name': 'Tower Structure'},
          {'value': false, 'align': 'left', 'class_name': 'Helicopter'}
        ]
      }
    },
    mounted () {
      // console.log('DataExplore component mounted')
      // console.log('baseUrl: ' + this.baseUrl)
    },
    computed: {
      // idToken: () => {
      //   return firebase.auth().currentUser.getIdToken(true)
      // }
      vpLayout () {
        const vpLayout = {}
        if (this.$vuetify.breakpoint.smAndDown) vpLayout.column = true
        return vpLayout
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Challenge/DataExplore.vue